import React from 'react';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectGroup,
  SelectLabel,
  SelectItem,
} from "@/components/ui/select"

export default function ChartMetricsSelection({ value, onChange, options = [] }) {
  const [selectedValue, setSelectedValue] = React.useState(value || options[0]?.value);

  // Update selected value when value prop changes
  React.useEffect(() => {
    if (value) {
      // Find the matching metric from options
      const matchingMetric = options.find(m => m.value === value);
      if (matchingMetric) {
        setSelectedValue(value);
      } else {
        // Fallback to first available metric if current value is invalid
        setSelectedValue(options[0]?.value);
      }
    }
  }, [value, options]);

  const handleValueChange = (v) => {
    if (!v) return;
    // Find the matching metric from options
    const matchingMetric = options.find(m => m.value === v);
    if (matchingMetric) {
      setSelectedValue(v);
      if (onChange) {
        onChange(v);
      }
    }
  };

  return (
    <Select
      value={selectedValue}
      onValueChange={handleValueChange}
    >
      <SelectTrigger className="w-[180px] bg-background text-foreground border border-border rounded-lg">
        <SelectValue>
          {options.find(m => m.value === selectedValue)?.label || "Select Metric"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-60 overflow-y-auto bg-background text-foreground border border-border">
        <SelectGroup>
          <SelectLabel>Chart Metric</SelectLabel>
          {options.map((m) => (
            <SelectItem key={m.value} value={m.value} className="text-foreground">
              {m.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
} 